import React from 'react';
import { styles } from '../AuthWrapper.styles';
import type { AuthFormState } from '../../hooks/useAuthForm';

const SignUpForm: React.FC<{ form: AuthFormState }> = ({ form }) => {
  const {
    email,
    setEmail,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    tosChecked,
    setTosChecked,
    tosError,
    setTosError,
    isSubmitting,
    handleSignUp,
  } = form;

  return (
    <form onSubmit={handleSignUp} style={styles.form}>
      <div style={styles.formGroup}>
        <label style={styles.label} htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          required
          style={styles.input}
          disabled={isSubmitting}
        />
      </div>
      <div style={styles.formGroup}>
        <label style={styles.label} htmlFor="password">Password</label>
        <input
          id="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Create a password (min 8 characters)"
          required
          style={styles.input}
          disabled={isSubmitting}
        />
      </div>
      <div style={styles.formGroup}>
        <label style={styles.label} htmlFor="confirmPassword">Confirm Password</label>
        <input
          id="confirmPassword"
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Confirm your password"
          required
          style={styles.input}
          disabled={isSubmitting}
        />
      </div>
      <div style={styles.tosContainer}>
        <label style={styles.tosLabel}>
          <input
            type="checkbox"
            checked={tosChecked}
            onChange={(e) => {
              setTosChecked(e.target.checked);
              if (e.target.checked) setTosError(false);
            }}
            style={styles.tosCheckbox}
            disabled={isSubmitting}
          />
          <span style={styles.tosText}>
            I agree to the{' '}
            <a href="/terms" style={styles.tosLink} target="_blank" rel="noopener noreferrer">
              Terms of Service
            </a>
            {' '}and{' '}
            <a href="/privacy" style={styles.tosLink} target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </span>
        </label>
        {tosError && (
          <p style={styles.tosError}>
            You must agree to the Terms of Service and Privacy Policy to create an account.
          </p>
        )}
      </div>
      <button
        type="submit"
        style={{
          ...styles.button,
          ...(!tosChecked || isSubmitting ? styles.buttonDisabled : {}),
        }}
        disabled={!tosChecked || isSubmitting}
      >
        {isSubmitting ? 'Creating account...' : 'Create Account'}
      </button>
    </form>
  );
};

export default SignUpForm;
